export default "__VITE_ASSET__B25D3la6__"